// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Products-module--arrow--gq4zP","arrow__icon":"Products-module--arrow__icon--1dgp2","active":"Products-module--active--172xG","products":"Products-module--products--ihTjO"};